import { z } from "zod";
import { userRightScopeEnumSchema } from "./enumSchemas";
import UserRightScopeEnum from "../../../enums/UserRightScopeEnum";

export const userRightSchema = z.object({
  create: z.boolean(),
  read: z.enum(UserRightScopeEnum),
  update: z.enum(UserRightScopeEnum),
  delete: z.enum(UserRightScopeEnum)
});